module.exports = __webpack_public_path__ + "img/s3.c15bff97.png";